import React, { useEffect, useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    CircularProgress,
    Typography,
    Snackbar,
    Alert
} from "@mui/material";
import { Visibility, Edit, Delete, ContentCopy } from "@mui/icons-material";
import WhatsAppTemplateModal from "./whatsapp-template";

const WhatsappList = () => {
    const [whatsappTemplates, setWhatsapppTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [message, setMessage] = useState("");
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState("success");
    const showSnackbar = (msg, type) => {
        setMessage(msg);
        setSeverity(type);
        setOpen(true);
    };

    const fetchTemplates = async () => {
        try {
            const response = await fetch("https://api.a2ajobs.com/api/wa-template");
            if (!response.ok) throw new Error("Failed to fetch templates");

            const data = await response.json();
            setWhatsapppTemplates(data);
        } catch (err) {
            setError(err.message);
        }
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTemplates();
    }, []);

    if (loading) return <CircularProgress />;
    if (error) return <Typography color="error">Error: {error}</Typography>;
    const handleEdit = (template) => {
        setSelectedTemplate(template);
        setOpenDialog(true);
    };
    const handleCloseDialog = () => {
        setOpenDialog(false);
        setSelectedTemplate(null);
        fetchTemplates();
    };
    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this template?")) return;

        try {
            const response = await fetch(`https://api.a2ajobs.com/api/wa-template-delete/${id}`, {
                method: "DELETE",
            });

            if (!response.ok) throw new Error("Failed to delete email template");

            setWhatsapppTemplates((prev) => ({
                ...prev,
                data: prev.data.filter((template) => template.id !== id),
            }));

            showSnackbar("Template deleted successfully", "success");

        } catch (err) {
            showSnackbar("Error deleting template:", "error");

        }
    };


    return (
        <>
            <TableContainer component={Paper} sx={{ borderRadius: 2, overflow: "hidden" }}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                            <TableCell>#</TableCell>
                            <TableCell>Whatsapp Title</TableCell>
                            <TableCell align="center">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {whatsappTemplates?.data?.map((email, index) => (
                            <TableRow key={email.id}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{email?.type}</TableCell>
                                <TableCell align="center">
                                    <IconButton color="success" onClick={() => handleEdit(email)}>
                                        <Visibility />
                                    </IconButton>
                                    <IconButton color="primary" onClick={() => handleEdit(email)}>
                                        <Edit />
                                    </IconButton>
                                    <IconButton color="error" onClick={() => handleDelete(email.id)}>
                                        <Delete />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <WhatsAppTemplateModal open={openDialog} onClose={handleCloseDialog} templateData={selectedTemplate} refreshTemplates={fetchTemplates} />
            <Snackbar
                open={open}
                autoHideDuration={3000}
                onClose={() => setOpen(false)}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert onClose={() => setOpen(false)} severity={severity} variant="filled">
                    {message}
                </Alert>
            </Snackbar>
        </>

    );
};

export default WhatsappList;
